import { Award, BookOpen, GraduationCap, Video } from "lucide-react";

/** Single shell-owned catalog for route paths, labels, subtitles, and module tones. */
export const TEACHER_NAVIGATION = [
  {
    id: "liveClasses",
    segment: "live-classes",
    path: "/teacher/live-classes",
    subtitle: "کلاس‌های آنلاین",
    lazy: () => import("@/features/classroom-sessions/route"),
    title: "کلاس آنلاین",
    icon: Video,
    activeColor: "text-module-sky-600",
    activeBg: "bg-module-sky-100",
    activeBorder: "border-module-sky-200",
  },
  {
    id: "homework",
    segment: "homework",
    path: "/teacher/homework",
    subtitle: "تکالیف و تمرین‌ها",
    lazy: () => import("@/features/homework/route"),
    title: "تکالیف",
    icon: BookOpen,
    activeColor: "text-module-amber-600",
    activeBg: "bg-module-amber-100",
    activeBorder: "border-module-amber-200",
  },
  {
    id: "scores",
    segment: "scores",
    path: "/teacher/scores",
    subtitle: "ثبت و ارزشیابی نمرات",
    lazy: () => import("@/features/scoring/route"),
    title: "نمرات",
    icon: GraduationCap,
    activeColor: "text-module-emerald-600",
    activeBg: "bg-module-emerald-100",
    activeBorder: "border-module-emerald-200",
  },
  {
    id: "conduct",
    segment: "conduct",
    path: "/teacher/conduct",
    subtitle: "موارد انضباطی و تشویقی",
    lazy: () => import("@/features/conduct/route"),
    title: "انضباط",
    icon: Award,
    activeColor: "text-module-violet-600",
    activeBg: "bg-module-violet-100",
    activeBorder: "border-module-violet-200",
  },
] as const;
